/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a08317faf7bb722eae48d675a4ede28d>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const EyeOpenStrikethroughIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.76 3.82.47 1.53 1.53.47l14 14-1.06 1.06-2.513-2.512A8.44 8.44 0 0 1 8 14C4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24A8.1 8.1 0 0 1 2.76 3.82m1.069 1.07a6.63 6.63 0 0 0-2.253 3.006.3.3 0 0 0 0 .208C2.509 10.656 5.057 12.5 8 12.5a6.9 6.9 0 0 0 2.836-.604l-1.312-1.311a3 3 0 0 1-4.108-4.108zm2.722 2.72q-.05.187-.051.39a1.5 1.5 0 0 0 1.889 1.448zM8 3.501q-.737 0-1.432.147L6.26 2.18A8.5 8.5 0 0 1 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24a8 8 0 0 1-1.31 2.295l-1.163-.947a6.5 6.5 0 0 0 1.064-1.864.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var _default = exports.default = EyeOpenStrikethroughIcon;